import { useQuery } from "@tanstack/react-query";
import { healthApi } from "../../lib/api";

/** Hidden while health is loading. The flag defaults to off. */
export function useAiFlag(): { enabled: boolean; pending: boolean } {
  const health = useQuery({
    queryKey: ["health"],
    queryFn: ({ signal }) => healthApi.get(signal),
    staleTime: 60_000,
  });
  return {
    enabled: health.data?.features?.ai_v1 === true,
    pending: health.isPending,
  };
}

export function useAiEnabled(): boolean {
  return useAiFlag().enabled;
}
